import { useAtomValue } from "jotai";
import { Suspense } from "react";
import { Tooltip } from "@zapier/design-system-beta";
import { IconButton } from "@zapier/design-system";
import {
  AssetType,
  isNodeLockedAtomFamily_SUSPENDS,
} from "@zapier/canvas-state";
import styles from "./AssetAccessChecker.module.css";

type Props = {
  assetId: string | undefined | null;
  interfaceProjectId: string | undefined;
  assetType: AssetType;
};

type LockIconButtonProps = {
  tooltipContent: string;
};

function LockIconButton({ tooltipContent }: LockIconButtonProps) {
  return (
    <div className={styles.root}>
      <Tooltip placement="top" content={tooltipContent}>
        <IconButton name="actionLock" variant="tertiary" />
      </Tooltip>
    </div>
  );
}

function SuspendedComponent({ assetId, interfaceProjectId, assetType }: Props) {
  const isNodeLocked = useAtomValue(
    isNodeLockedAtomFamily_SUSPENDS({
      assetId,
      interfaceProjectId,
      assetType,
    }),
  );

  if (isNodeLocked) {
    return (
      <LockIconButton
        tooltipContent={`You don't have access to this ${assetType}.`}
      />
    );
  }

  return null;
}

export function AssetAccessChecker(props: Props) {
  return (
    <Suspense fallback={null}>
      <SuspendedComponent {...props} />
    </Suspense>
  );
}
